export default function Footer() {
  return <footer className="mt-auto py-6 border-t bg-card">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-muted-foreground">© 2025 Skylink Aviation. All rights reserved </p>
      </div>
    </footer>;
}